import { UnstyledButton } from "@mantine/core"
import { modals } from "@mantine/modals"
import { observer } from "mobx-react-lite"
import React from "react"
import { Form } from "./Form";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode
  target: string
}

export const ParticipationRequestModal = observer(function ScheduleEventRemoveModal(
  {
    children, target,
  }: Props) {

  const openDeleteModal = () =>
    modals.open({
      zIndex: 1001,
      closeOnClickOutside: false,
      title: "Оставить заявку",
      centered: true,
      children: <Form target={target}/>,
    })

  return (
    <UnstyledButton onClick={openDeleteModal}>
      {children}
    </UnstyledButton>
  )
})
